import React, { useEffect, useRef, useState } from "react";
import {
  obtenerSolicitudesPorEstados,
  obtenerCarrerasMasEstudiantes,
  obtenerEstadisticasRazones,
  obtenerSolicitudesPorMes,
  obtenerCarrerasMayorInteres,
  obtenerSolicitudesPorNiveles,
  obtenerNivelCarreras,
  obtenerSolicitudesUsuario,
  obtenerSolicitudesCarrerasPorNivel,
} from "../../redux/genericosSlice";
import { useDispatch, useSelector } from "react-redux";
import Charts from "./Charts";
import infoIMG from "../../SVG/InformacionpersonalCenfotec.svg";
import GoogleChartContainer from "./GoogleChartContainer";
import { getAdminHombePage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { _translateValue } from "../translation-gestor/translateValue";

const SCREEN_NAME = "PantallaDashboard";

let colors = [
  "#B3E1F9",
  "#5795e0",
  "#00479B",
  "#16B2BF",
  "#68A1FF",
  "#A0C0CE",
  "#4FC3F7",
  "#16B2BF",
  "006064",
];

function Dashboard({ imgNoResult, msgNoResult }) {
  const dispatch = useDispatch();
  const rangoFechas = useRef();
  const [fechaInicio, setFechaInicio] = useState();
  const [fechaFin, setFechaFin] = useState();
  const [datosSolicitudesAtendidas, setDatosSolicitudesAtendidas] = useState(2);
  const [datosNivelCarrera, setDatosNivelCarrera] = useState(1);
  const { locale } = useLocale();
  const [adminHomePage, setAdminHomePage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [translatedNiveles, setTranslatedNiveles] = useState({});
  const [translatedCarreras, setTranslatedCarreras] = useState({});
  const [translatedRazones, setTranslatedRazones] = useState({});
  const [translatedMeses, setTranslatedMeses] = useState({});
  const [translatedNivelesAcademicos, setTranslatedNivelesAcademicos] = useState({});
  const [isTranslating, setIsTranslating] = useState(false);
  const estados = {
    18: adminHomePage?.request_reaprove || "Preaprobadas",
    9: adminHomePage?.request_sent || "Enviadas",
    10: adminHomePage?.request_aprove || "Aprobadas",
    13: adminHomePage?.request_refused || "Rechazadas",
    0: adminHomePage?.request_total || "Total",
  };

  const {
    solicitudesPorEstados,
    solicitudesPorCarrera,
    solicitudesPorMeses,
    solicitudesMayoresRazones,
    solicitudesPorNiveles,
    nivelesCarreras,
    solicitudesCarrerasPorNivel,
    solicitudesUsuarioActual,
  } = useSelector((state) => state.genericos);

  useEffect(() => {
    dispatch(obtenerCarrerasMasEstudiantes({ fechaInicio, fechaFin }));
    dispatch(obtenerSolicitudesPorEstados({ fechaInicio, fechaFin }));
    dispatch(obtenerSolicitudesPorNiveles({ fechaInicio, fechaFin }));
    dispatch(obtenerSolicitudesPorMes({ fechaInicio, fechaFin }));
    dispatch(obtenerCarrerasMayorInteres({ fechaInicio, fechaFin }));
    dispatch(obtenerEstadisticasRazones({ fechaInicio, fechaFin }));
    dispatch(obtenerNivelCarreras({ fechaInicio, fechaFin }));
  }, [dispatch, fechaInicio, fechaFin]);

  const filtrarCarrerasPorNiveles = (e) => {
    const nivel = e.target.value;
    if (nivel != 1) {
      dispatch(
        obtenerSolicitudesCarrerasPorNivel({ nivel, fechaInicio, fechaFin })
      );
      setDatosNivelCarrera(2);
    } else setDatosNivelCarrera(1);
  };

  const getFirstDate = (dias) => {
    const hoy = new Date();
    let calculado = new Date(),
      dateResul = hoy.getDate() - dias;
    calculado.setDate(dateResul);
    return getDateR(calculado);
  };

  const getDateR = (fecha) => {
    const formato = "yyyy-mm-dd";
    const map = {
      dd: fecha.getDate(),
      mm: fecha.getMonth() + 1,
      yyyy: fecha.getFullYear(),
    };
    return formato.replace(/dd|mm|yyyy/gi, (matched) => map[matched]);
  };

  const mostrarFiltroPorFechas = (e) => {
    if (e.target.value == 1) {
      setFechaInicio("");
      setFechaFin("");
    } else if (e.target.value == 5) {
      rangoFechas.current.classList.add("visible");
    } else {
      setFechaFin(getDateR(new Date()));
      setFechaInicio(getFirstDate(e.target.value));
      rangoFechas.current.classList.remove("visible");
    }
  };

  const filtrarEstadisticasPorEstados = (e) => {
    if (e.target.value == 1) {
      dispatch(obtenerSolicitudesPorEstados());
      setDatosSolicitudesAtendidas(2);
    } else {
      dispatch(obtenerSolicitudesUsuario());
      setDatosSolicitudesAtendidas(1);
    }
  };

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getAdminHombePage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setAdminHomePage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setAdminHomePage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  // Efecto para traducir los datos cuando lleguen o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      // Verificar si hay datos para traducir
      const hasNiveles = solicitudesPorNiveles && Array.isArray(solicitudesPorNiveles) && solicitudesPorNiveles.length > 0;
      const hasCarreras = solicitudesPorCarrera && Array.isArray(solicitudesPorCarrera) && solicitudesPorCarrera.length > 0;
      const hasCarrerasPorNivel = solicitudesCarrerasPorNivel && Array.isArray(solicitudesCarrerasPorNivel) && solicitudesCarrerasPorNivel.length > 0;
      const hasRazones = solicitudesMayoresRazones && Array.isArray(solicitudesMayoresRazones) && solicitudesMayoresRazones.length > 0;
      const hasMeses = solicitudesPorMeses && Array.isArray(solicitudesPorMeses) && solicitudesPorMeses.length > 0;
      const hasNivelesAcademicos = nivelesCarreras && Array.isArray(nivelesCarreras) && nivelesCarreras.length > 0;

      // Si no hay datos, no hacer nada
      if (!hasNiveles && !hasCarreras && !hasCarrerasPorNivel && !hasRazones && !hasMeses && !hasNivelesAcademicos) {
        setIsTranslating(false);
        return;
      }

      // Iniciar traducción
      setIsTranslating(true);

      const nivelTranslations = {};
      const carreraTranslations = {};
      const razonTranslations = {};
      const mesTranslations = {};
      const nivelAcademicoTranslations = {};

      // Traducir niveles de carreras
      if (hasNiveles) {
        const nivelPromises = solicitudesPorNiveles.map(async (item) => {
          if (item.nivelCarreraNombre) {
            const translated = await _translateValue(SCREEN_NAME, item.nivelCarreraNombre, locale);
            nivelTranslations[item.nivelCarreraNombre] = translated;
          }
        });
        await Promise.all(nivelPromises);
      }

      // Traducir carreras
      if (hasCarreras) {
        const carreraPromises = solicitudesPorCarrera.map(async (item) => {
          if (item.carreraNombre) {
            const translated = await _translateValue(SCREEN_NAME, item.carreraNombre, locale);
            carreraTranslations[item.carreraNombre] = translated;
          }
        });
        await Promise.all(carreraPromises);
      }

      // Traducir carreras por nivel
      if (hasCarrerasPorNivel) {
        const carreraPorNivelPromises = solicitudesCarrerasPorNivel.map(async (item) => {
          if (item.carreraNombre) {
            const translated = await _translateValue(SCREEN_NAME, item.carreraNombre, locale);
            carreraTranslations[item.carreraNombre] = translated;
          }
        });
        await Promise.all(carreraPorNivelPromises);
      }

      // Traducir razones
      if (hasRazones) {
        const razonPromises = solicitudesMayoresRazones.map(async (item) => {
          if (item.razonNombre) {
            const translated = await _translateValue(SCREEN_NAME, item.razonNombre, locale);
            razonTranslations[item.razonNombre] = translated;
          }
        });
        await Promise.all(razonPromises);
      }

      // Traducir meses
      if (hasMeses) {
        const mesPromises = solicitudesPorMeses.map(async (item) => {
          if (item.mes) {
            const translated = await _translateValue(SCREEN_NAME, item.mes, locale);
            mesTranslations[item.mes] = translated;
          }
        });
        await Promise.all(mesPromises);
      }

      // Traducir niveles académicos
      if (hasNivelesAcademicos) {
        const nivelAcademicoPromises = nivelesCarreras.map(async (item) => {
          if (item.nivelAcademicoNombre) {
            const translated = await _translateValue(SCREEN_NAME, item.nivelAcademicoNombre, locale);
            nivelAcademicoTranslations[item.nivelAcademicoNombre] = translated;
          }
        });
        await Promise.all(nivelAcademicoPromises);
      }

      // Actualizar estados y finalizar traducción
      setTranslatedNiveles(nivelTranslations);
      setTranslatedCarreras(carreraTranslations);
      setTranslatedRazones(razonTranslations);
      setTranslatedMeses(mesTranslations);
      setTranslatedNivelesAcademicos(nivelAcademicoTranslations);
      setIsTranslating(false);
    };

    translateData();
  }, [solicitudesPorNiveles, solicitudesPorCarrera, solicitudesCarrerasPorNivel, solicitudesMayoresRazones, solicitudesPorMeses, nivelesCarreras, locale]);

  if (isLoadingContent || isTranslating) {
    return (
      <GoogleChartContainer>
        {(google) => (
          <main className="main-admin">
            <div id="dashboard">
              {/* Skeleton para controles de fecha */}
              <div className="form-group" id="date-range-container">
                <Skeleton.Input style={{ width: '100%', height: 60, minWidth: '600px' }} active />
              </div>

              <div className="grid-container col-2 col-lg-2 col-sm-12">
                {/* Skeleton para sección de bienvenida */}
                <div className="grid-item">
                  <section className="section welcome-dashboard-text">
                    <Skeleton.Input style={{ width: '100%', height: 150, minWidth: '400px' }} active />
                  </section>
                </div>

                {/* Skeleton para estadísticas de solicitudes */}
                <div className="grid-item">
                  <section>
                    <Skeleton.Input style={{ width: '100%', height: 200, minWidth: '400px' }} active />
                  </section>
                </div>

                {/* Skeleton para gráfico principal */}
                <div className="grid-item grid-item-large">
                  <section className="section-card graphic-card">
                    <Skeleton.Input style={{ width: '100%', height: 350, minWidth: '500px' }} active />
                  </section>
                </div>

                {/* Skeleton para gráficos secundarios */}
                <div className="grid-item">
                  <section className="section-card graphic-card">
                    <Skeleton.Input style={{ width: '100%', height: 300, minWidth: '400px' }} active />
                  </section>
                </div>

                <div className="grid-item">
                  <section className="section-card graphic-card">
                    <Skeleton.Input style={{ width: '100%', height: 300, minWidth: '400px' }} active />
                  </section>
                </div>

                <div className="grid-item">
                  <section className="section-card graphic-card">
                    <Skeleton.Input style={{ width: '100%', height: 300, minWidth: '400px' }} active />
                  </section>
                </div>
              </div>
            </div>
          </main>
        )}
      </GoogleChartContainer>
    );
  }

  return (
    <GoogleChartContainer>
      {(google) => (
        <main className="main-admin">
          <div id="dashboard">
            <div className="form-group" id="date-range-container">
              <label>{adminHomePage?.daterange || "Rango de fechas:"}</label>
              <select
                className="dashboard-control mr-1"
                onChange={(e) => mostrarFiltroPorFechas(e)}
              >
                <option value={1}>{adminHomePage?.daterange_optionA || "desde siempre"}</option>
                <option value={7}>{adminHomePage?.daterange_optionB || "últimos 7 días"}</option>
                <option value={30}>{adminHomePage?.daterange_optionC || "últimos 30 dias"}</option>
                <option value={365}>{adminHomePage?.daterange_optionD || "último año"}</option>
                <option value={5}>{adminHomePage?.daterange_optionE || "especificar rango"}</option>
              </select>

              <div ref={rangoFechas}>
                <span>{adminHomePage?.range_between || "Entre"}</span>
                <input
                  onChange={(e) => setFechaInicio(e.target.value)}
                  type="date"
                  defaultValue={fechaInicio ? fechaInicio : getFirstDate(7)}
                  className="form-control"
                ></input>
                <span>{adminHomePage?.range_and || "y"}</span>
                <input
                  onChange={(e) => setFechaFin(e.target.value)}
                  type="date"
                  defaultValue={fechaFin ? fechaFin : getDateR(new Date())}
                  className="form-control"
                ></input>
              </div>
            </div>

            <div className="grid-container col-2 col-lg-2 col-sm-12">
              <div className="grid-item">
                <section className="section welcome-dashboard-text">
                  <div className="d-flex">
                    <img
                      className="dboard-img"
                      src={infoIMG}
                      alt="Ilustración de gestión"
                    ></img>
                    <div>
                      <h3>{adminHomePage?.title || "ADMINISTRACIÓN CENFOTEC"}</h3>

                      <p>
                        {adminHomePage?.description || "Gestione de manera segura las solicitudes y actividades correspondientes"}
                      </p>
                    </div>
                  </div>
                </section>
              </div>
              <div className="grid-item">
                <section>
                  <div>
                    <div className="d-flex">
                      <h3 className="mr-2">{adminHomePage?.request_title || "SOLICITUDES"}</h3>
                      <select
                        className="dashboard-control"
                        onChange={(e) => filtrarEstadisticasPorEstados(e)}
                      >
                        <option value={1}>{adminHomePage?.requests_optionA || "Solicitudes a nivel general"}</option>
                        <option value={2}>{adminHomePage?.requests_optionB || "Solicitudes que has atendido"}</option>
                      </select>
                    </div>
                    <div>
                      <ul
                        className="d-flex bottom-align p-0"
                        id="count-solicitudes-container"
                      >
                        {datosSolicitudesAtendidas == 2 ? (
                          solicitudesPorEstados.length > 0 ? (
                            solicitudesPorEstados.map((estado, i) => {
                              return (
                                <li
                                  className="short-text mb-9"
                                  style={{
                                    borderColor:
                                      estado.estadoId == 8
                                        ? "#c9ba74"
                                        : estado.estadoId == 10
                                        ? "#7cd77c"
                                        : estado.estadoId == 13
                                        ? "#b57676"
                                        : "var(--color-accent)",
                                  }}
                                  key={i}
                                >
                                  <i className="material-icons-outlined"></i>
                                  <div>
                                    <div>
                                      <span>{estados[estado.estadoId]}</span>
                                    </div>
                                    <div className="number-card">
                                      <span className="big-number">
                                        {estado.solicitudes}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              );
                            })
                          ) : (
                            <div className="no-results-container">
                              <img
                                src={imgNoResult}
                                alt="Imagen sin resultados"
                              />
                              <h3>{msgNoResult}</h3>
                            </div>
                          )
                        ) : solicitudesUsuarioActual.length > 0 ? (
                          solicitudesUsuarioActual.map((estado, i) => {
                            return (
                              <li
                                className="short-text mb-9"
                                style={{
                                  borderColor:
                                    estado.estadoId == 8
                                      ? "#c9ba74"
                                      : estado.estadoId == 10
                                      ? "#7cd77c"
                                      : estado.estadoId == 13
                                      ? "#b57676"
                                      : "var(--color-accent)",
                                }}
                                key={i}
                              >
                                <i className="material-icons-outlined"></i>
                                <div>
                                  <div>
                                    <span>{estados[estado.estadoId]}</span>
                                  </div>
                                  <div className="number-card">
                                    <span className="big-number">
                                      {estado.solicitudes}
                                    </span>
                                  </div>
                                </div>
                              </li>
                            );
                          })
                        ) : (
                          <div className="no-results-container">
                            <img
                              src={imgNoResult}
                              alt="Imagen sin resultados"
                            />
                            <h3>{msgNoResult}</h3>
                          </div>
                        )}
                      </ul>
                    </div>
                  </div>
                </section>
              </div>

              <div className="grid-item grid-item-large">
                <section className="section-card graphic-card">
                  <select
                    className="dashboard-control"
                    onChange={(e) => filtrarCarrerasPorNiveles(e)}
                    defaultValue={datosNivelCarrera}
                    placeholder="Filtrar carreras por nivel owow"
                  >
                    <option value={1} hidden>
                      {adminHomePage?.filterbylevel || "Filtrar carreras por nivel"}
                    </option>
                    <option value={1}>{adminHomePage?.filterbylevel_all || "Todos los niveles"}</option>
                    {nivelesCarreras?.map((nivel) => (
                      <option key={nivel.nivelId} value={nivel.nivelId}>
                        {translatedNivelesAcademicos[nivel.nivelAcademicoNombre] || nivel.nivelAcademicoNombre}
                      </option>
                    ))}
                  </select>

                  {datosNivelCarrera == 1 ? (
                    solicitudesPorNiveles?.length > 0 ? (
                      <Charts
                        google={google}
                        title={adminHomePage?.char_titleO || "Solicitudes por niveles acádemicos"}
                        array={[
                          [
                            "Nivel",
                            "Cantidad de solicitudes",
                            { role: "style" },
                          ],
                          ...solicitudesPorNiveles.map((r, i) => [
                            translatedNiveles[r.nivelCarreraNombre] || r.nivelCarreraNombre,
                            r.solicitudes,
                            colors[i],
                          ]),
                        ]}
                        chartType="columnBar"
                      />
                    ) : (
                      <div className="no-results-container">
                        <img src={imgNoResult} alt="Imagen sin resultados" />
                        <h3>{msgNoResult}</h3>
                      </div>
                    )
                  ) : solicitudesCarrerasPorNivel?.length > 0 ? (
                    <Charts
                      google={google}
                      title={adminHomePage?.char_titleO || "Solicitudes por niveles acádemicos"}
                      array={[
                        ["Nivel", "Cantidad de solicitudes", { role: "style" }],
                        ...solicitudesCarrerasPorNivel.map((r, i) => [
                          translatedCarreras[r.carreraNombre] || r.carreraNombre,
                          r.solicitudes,
                          colors[i],
                        ]),
                      ]}
                      chartType="columnBar"
                    />
                  ) : (
                    <div className="no-results-container">
                      <img src={imgNoResult} alt="Imagen sin resultados" />
                      <h3>{msgNoResult}</h3>
                    </div>
                  )}
                </section>
              </div>

              {solicitudesPorCarrera?.length > 0 ? (
                <div className="grid-item">
                  <section className="section-card graphic-card">
                    <Charts
                      google={google}
                      title={adminHomePage?.char_titleT || "Carreras de mayor interés"}
                      array={[
                        [
                          "Carrera",
                          "Cantidad de solicitudes",
                          { role: "style" },
                        ],
                        ...solicitudesPorCarrera.map((r, i) => [
                          translatedCarreras[r.carreraNombre] || r.carreraNombre,
                          r.cantidadDeEstudiantes,
                          colors[i],
                        ]),
                      ]}
                      chartType="bar"
                    />
                  </section>
                </div>
              ) : null}

              {solicitudesMayoresRazones?.length > 0 ? (
                <div className="grid-item">
                  <section className="section-card graphic-card">
                    <Charts
                      google={google}
                      title={adminHomePage?.char_titleTR || "Razones principales por las que se elige CENFOTEC..."}
                      array={[
                        ["Razon", "Veces que se presenta", { role: "style" }],
                        ...solicitudesMayoresRazones.map((r, i) => [
                          translatedRazones[r.razonNombre] || r.razonNombre,
                          r.cantidadDeEstudiantes,
                          colors[i],
                        ]),
                      ]}
                      chartType="pie"
                    />
                  </section>
                </div>
              ) : null}

              {solicitudesPorMeses?.length > 0 ? (
                <div className="grid-item">
                  <section className="section-card graphic-card">
                    <Charts
                      google={google}
                      title={adminHomePage?.char_titleF || "Solicitudes por meses del año..."}
                      array={[
                        ["Mes", "Solicitudes", { role: "style" }],
                        ...solicitudesPorMeses.map((r, i) => [
                          translatedMeses[r.mes] || r.mes,
                          r.cantidadDeSolicitudes,
                          colors[i],
                        ]),
                      ]}
                      chartType="columBar"
                    />
                  </section>
                </div>
              ) : null}
            </div>
          </div>
        </main>
      )}
    </GoogleChartContainer>
  );
}

export default Dashboard;
